import { OrderItem } from '@cat-ecom/common/utils/productFormUtils';
import { GENERAL } from 'constants/common';

export const EMPTY_ITEM: OrderItem = {
  quantity: '',
  itemNumber: '',
  serialNumber: '',
  lineItemNote: '',
  customerPartNumber: '',
  customerItemNumber: '',
  page: GENERAL
};

export const MAX_LENGTH_EQUIPMENT_ITEM_NOTE = 20;
export const MAX_LENGTH_NOTES_CUSTOMER_ITEM = 50;
export const MAX_LENGTH_CUSTOMER_PART = 10;
export const MAX_LENGTH_CUSTOMER_ITEM = 5;

export const ITEM_NUMBER_VALIDATION_REGEX =
  /^[a-zA-Z0-9!#$()*+,-./:;=?{}_ `"&\\]+$/;

export const LINE_ITEM_NOTES_VALIDATION_REGEX = /^[^\\<>[\]{}&()]*$/;
export const EQUIPMENT_VALIDATION_REGEX = /^[^<>]*$/;
